<template>
    <div class="contacts-groups-edit">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Editar Grupo</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Formulário de Edição e exclusáo -->
        <mu-form-group type="edit"></mu-form-group>

    </div>
</template>

<script>
    export default {
        name: 'app-contacts-groups-edit',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Contatos',
                        route: 'app.contacts',
                        disabled: false
                    },
                    {
                        text: 'Grupos',
                        route: 'app.contacts.groups',
                        disabled: false
                    },
                    {
                        text: 'Editar Grupo',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
